import { useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

const Portal = ({ children }) => {
    const el = useRef(document.createElement('div')).current;
    const root = useRef(document.getElementById('portal-root')).current;
    useEffect(
        () => {
            if (!root) {
                throw new Error(`Cannot find DOM element with id: portal-root`);
            }
            root.appendChild(el);

            return () => root.removeChild(el);
        }, []
    );
    return el ? createPortal(children, el) : null;
};

export default Portal;
